// extracted by mini-css-extract-plugin
export default {"container":"About_container__HGEHz","section":"About_section__ZGtko"};